import {Component, Inject} from '@angular/core';
import {User} from "../../../../classes/user";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Dog} from "../../../../classes/dog";
import {Note} from "../../../../classes/note";
import {kanNotesService} from "../../../services/services/notes";
import {getDateString} from "../../../../utils/dateFormat";

@Component({
    selector: 'kan-note-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanNoteDialog {
    public user: User;
    public dog: Dog;
    public note: Note = new Note();
    public start: string = getDateString(new Date());
    public notes: string;
    public isNew: boolean = true;

    public noteForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanNoteDialog>,
                private formBuilder: FormBuilder,
                private notesService: kanNotesService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.user) {
            this.user = this.data.user;
        }

        if (this.data && this.data.userId) {
            this.note.userId = this.data.userId;
        }

        if (this.data && this.data.dog) {
            this.dog = this.data.dog;
        }

        if (this.data && this.data.dogId) {
            this.note.dogId = this.data.dogId;
        }

        if (this.data && this.data.note) {
            this.note = this.data.note;
            this.start = getDateString(this.note.start);
            this.notes = this.note.notes;
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.noteForm = this.formBuilder.group({
            start: new FormControl(this.start, [Validators.required]),
            notes: new FormControl(this.notes, [Validators.required])
        });
    }

    public addNote(event: any) {
        if (this.user) {
            this.note.userId = this.user.id;
        }

        if (this.dog) {
            this.note.dogId = this.dog.id;
        }

        this.note.start = new Date(this.start);
        this.note.notes = this.notes;

        this.notesService.addNote(this.note)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateNote(event: any) {

        this.note.start = new Date(this.start);
        this.note.notes = this.notes;

        this.notesService.updateNote(this.note)
            .then((note) => {
                this.dialogRef.close('upsdate');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/note-dialog/component.ts